
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useCalendarDefaults = () => {
  const [calendarDefaults, setCalendarDefaults] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const fetchCalendarDefaults = async () => {
      try {
        setIsLoading(true);

        const { data, error } = await supabase
          .from('admin_settings')
          .select('calendar_defaults')
          .eq('id', 1)
          .single();

        if (error) {
          throw error;
        }

        if (data && data.calendar_defaults) {
          setCalendarDefaults(data.calendar_defaults);
        } else {
          // Set fallback defaults if none are found
          setCalendarDefaults({
            business_hours: [
              {
                daysOfWeek: [1, 2, 3, 4, 5], // Monday to Friday
                startTime: '09:00',
                endTime: '17:00'
              }
            ],
            time_range: {
              minTime: '08:00:00',
              maxTime: '20:00:00'
            },
            slot_duration: '00:30:00',
            initial_view: 'timeGridDay',
            mobile_view: 'timeGridDay'
          });
        }
      } catch (error: any) {
        console.error('Error fetching calendar defaults:', error);
        
        // Only show error toast if it's not a permission issue (regular users don't need admin settings)
        const isPermissionError = error?.code === 'PGRST116' || error?.message?.includes('permission') || error?.message?.includes('policy');
        
        if (!isPermissionError) {
          toast({
            variant: "destructive",
            title: "Error",
            description: "Failed to load calendar defaults",
          });
        }
        // Set fallback defaults on error
        setCalendarDefaults({
          business_hours: [
            {
              daysOfWeek: [1, 2, 3, 4, 5], // Monday to Friday
              startTime: '09:00',
              endTime: '17:00'
            }
          ],
          time_range: {
            minTime: '08:00:00',
            maxTime: '20:00:00'
          },
          slot_duration: '00:30:00',
          initial_view: 'timeGridDay',
          mobile_view: 'timeGridDay'
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchCalendarDefaults();
  }, [toast]);

  return { calendarDefaults, isLoading };
};
